export const TopEndpoints = {
	topAnime: '/top/anime',
	topManga: '/top/manga',
	topCharacters: '/top/characters'
} as const
